'use strict';

module.exports = function (ngModule) {
    ngModule.directive('head', require('./head'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/head/index.js
 **/